import { z } from 'zod';
import { FieldConfig, COMPONENT_TYPES } from './types';
import {
    COUNTY_REGEX,
    FIRST_NAME_REGEX,
    HOUSEHOLD_REGEX,
    LAST_NAME_REGEX,
    PHONE_REGEX,
    SSN_REGEX,
    ZIP_CODE_REGEX,
} from '../../../utils/validators/regex';
import { PHONE_NUMBER_MASK } from '../../../constants/members/members.constants';
import { Gender } from '../../../constants/common.constants';

const GENDER_OPTIONS = Object.values(Gender) as [string, ...string[]];

export const getFieldConfigs = (intl: any): Record<string, FieldConfig> => ({
    firstName: {
        labelId: 'resetPassword.questions.firstName.label',
        getValidation: () =>
            z.string().regex(
                FIRST_NAME_REGEX,
                intl.formatMessage({
                    id: 'resetPassword.questions.firstName.required',
                }),
            ),
        componentType: COMPONENT_TYPES.INPUT,
    },
    lastName: {
        labelId: 'resetPassword.questions.lastName.label',
        getValidation: () =>
            z.string().regex(
                LAST_NAME_REGEX,
                intl.formatMessage({
                    id: 'resetPassword.questions.firstName.required',
                }),
            ),
        componentType: COMPONENT_TYPES.INPUT,
    },
    zipCode: {
        labelId: 'resetPassword.questions.zipCode.label',
        getValidation: () =>
            z
                .string()
                .min(1, intl.formatMessage({ id: 'resetPassword.questions.zipCode.required' }))
                .regex(ZIP_CODE_REGEX, intl.formatMessage({ id: 'resetPassword.questions.zipCode.invalid' })),
        componentType: COMPONENT_TYPES.INPUT,
    },
    county: {
        labelId: 'resetPassword.questions.county.label',
        getValidation: () =>
            z.string().regex(COUNTY_REGEX, intl.formatMessage({ id: 'resetPassword.questions.county.invalid' })),
        componentType: COMPONENT_TYPES.INPUT,
    },
    sizeOfHousehold: {
        labelId: 'resetPassword.questions.sizeOfHousehold.label',
        getValidation: () =>
            z
                .string()
                .min(1, intl.formatMessage({ id: 'resetPassword.questions.sizeOfHousehold.required' }))
                .regex(HOUSEHOLD_REGEX, intl.formatMessage({ id: 'resetPassword.questions.sizeOfHousehold.invalid' })),
        componentType: COMPONENT_TYPES.INPUT,
        className: 'input-sm',
    },
    phoneNo: {
        labelId: 'resetPassword.questions.phoneNo.label',
        getValidation: () =>
            z.string().regex(PHONE_REGEX, intl.formatMessage({ id: 'resetPassword.questions.phoneNo.invalid' })),
        componentType: COMPONENT_TYPES.MASKED,
        mask: PHONE_NUMBER_MASK,
        placeholder: '(___) ___-____',
        className: 'input-sm',
    },
    ssn: {
        labelId: 'resetPassword.questions.ssn.label',
        getValidation: () =>
            z
                .string()
                .min(1, intl.formatMessage({ id: 'resetPassword.questions.ssn.required' }))
                .regex(SSN_REGEX, intl.formatMessage({ id: 'resetPassword.questions.ssn.invalid' })),
        componentType: COMPONENT_TYPES.INPUT,
        className: 'input-sm',
    },
    dob: {
        labelId: 'resetPassword.questions.dob.label',
        getValidation: () =>
            z.union([
                z.date().max(
                    new Date(),
                    intl.formatMessage({
                        id: 'resetPassword.questions.dob.invalid',
                    }),
                ),
                z.string().min(
                    10,
                    intl.formatMessage({
                        id: 'resetPassword.questions.dob.required',
                    }),
                ),
            ]),
        componentType: COMPONENT_TYPES.DATE,
    },
    gender: {
        labelId: 'resetPassword.questions.gender.label',
        getValidation: () =>
            z.enum(GENDER_OPTIONS, {
                errorMap: () => ({
                    message: intl.formatMessage({ id: 'resetPassword.questions.gender.required' }),
                }),
            }),
        componentType: COMPONENT_TYPES.RADIO,
        options: [
            { value: 'male', text: intl.formatMessage({ id: 'resetPassword.questions.gender.label.male' }) },
            { value: 'female', text: intl.formatMessage({ id: 'resetPassword.questions.gender.label.female' }) },
        ],
    },
});
